import appConfig from 'app-config';

import azarReferenceColor from './referenceColor/azarReferenceColor';
import ReferenceColor from './referenceColor/referenceColorType';
import vividiReferenceColor from './referenceColor/vividiReferenceColor';
import azarSystemColor from './systemColor/azarSystemColor';
import { SystemColor } from './systemColor/systemColorType';
import vividiSystemColor from './systemColor/vividiSystemColor';

const getServiceColors = () => {
  switch (appConfig.serviceCode) {
    case 'vividi':
      return {
        referenceColor: vividiReferenceColor,
        systemColor: vividiSystemColor,
      };
    case 'azar':
    default:
      return {
        referenceColor: azarReferenceColor,
        systemColor: azarSystemColor,
      };
  }
};

export type ColorKey = keyof SystemColor;

export const createSystemColor = (isDarkMode: boolean) => {
  const { referenceColor, systemColor } = getServiceColors();

  return Object.fromEntries(
    Object.entries(systemColor).map(([key, value]) => {
      const colorValue = referenceColor[value as keyof ReferenceColor];

      if (typeof colorValue === 'string') {
        return [key, colorValue];
      }

      return [key, colorValue[isDarkMode ? 'dark' : 'light']];
    })
  ) as Record<ColorKey, string>;
};
